<template>
    <v-container class="pt-4 pb-12 py-sm-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Combos</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Combos',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn :disabled="dataList.loading" type="button" elevation="0" color="primary" dark
                            @click="$router.push('/combos/novo')">
                            <v-icon class="mr-1" small>mdi-plus</v-icon> Novo Combo
                        </v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mb-4" align="center">
            <v-col cols="12" sm="4" md="3">
                <v-text-field
                    v-model="search"
                    prepend-inner-icon="mdi-magnify"
                    placeholder="Buscar combo..."
                    outlined
                    dense
                    hide-details
                    background-color="white"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <v-btn-toggle v-model="activeTab" mandatory dense color="primary" class="elevation-0">
                    <v-btn v-for="tab in tabs" :key="tab.value" :value="tab.value" small outlined>
                        {{ tab.label }}
                    </v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>

        <v-row v-if="filteredCombos.length > 0">
            <v-col 
                v-for="combo in filteredCombos" 
                :key="combo.id" 
                cols="12" 
                sm="6" 
                md="4"
            >
                <v-card outlined class="combo-card pa-5">
                    <div class="card-top d-flex justify-space-between align-center mb-4">
                        <h3 class="card-title">{{ combo.nome }}</h3>
                        <div class="d-flex align-center ga-2">
                            <v-switch
                                :input-value="combo.habilitado"
                                @change="toggleStatus(combo)"
                                hide-details
                                dense
                                color="success"
                                class="ma-0 pa-0"
                            ></v-switch>
                            <span :class="combo.habilitado ? 'green--text' : 'error--text'" class="text-caption font-weight-bold">
                                {{ combo.habilitado ? 'Habilitado' : 'Desabilitado' }}
                            </span>
                        </div>
                    </div>

                    <div class="values-row d-flex align-center justify-space-between mb-4">
                        <div class="value-box value-pago pa-3 text-center flex-grow-1">
                            <span class="value-label d-block text-caption font-weight-bold grey--text text--darken-1 text-uppercase">Valor Pago</span>
                            <span class="value-amount font-weight-black warning--text">{{ combo.valorPago | currency }}</span>
                        </div>
                        
                        <v-icon color="grey lighten-1" class="mx-2">mdi-arrow-right</v-icon>

                        <div class="value-box value-recebido pa-3 text-center flex-grow-1">
                            <span class="value-label d-block text-caption font-weight-bold grey--text text--darken-1 text-uppercase">Valor Recebido</span>
                            <span class="value-amount font-weight-black green--text">{{ combo.valorRecebido | currency }}</span>
                        </div>
                    </div>

                    <div class="text-center mb-4" v-if="combo.valorRecebido > combo.valorPago">
                        <v-chip color="blue lighten-5" text-color="primary" small class="font-weight-bold" outlined>
                            +{{ (combo.valorRecebido - combo.valorPago) | currency }} de bônus
                        </v-chip>
                    </div>

                    <v-divider class="mb-4"></v-divider>

                    <v-row align="center" class="ga-2 px-3">
                    <v-btn small color="primary-200" style="flex: 1"
    @click="$router.push(`/combos/${combo.id}`)">
    <v-icon left>mdi-pencil-outline</v-icon>
    Editar
</v-btn>
<v-btn small style="flex: 1; background-color: #f44336 !important; color: white !important;"
    @click="confirmarExclusao(combo)">
    <v-icon left>mdi-delete-outline</v-icon>
    Excluir
</v-btn>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-else justify="center" align="center" class="py-12">
            <v-col cols="12" class="text-center">
                <v-icon size="64" color="grey lighten-1">mdi-package-variant</v-icon>
                <p class="text-h6 font-weight-bold grey--text text--darken-2 mt-3 mb-1">Nenhum combo encontrado</p>
                <p class="text-body-2 grey--text mb-4">Crie seu primeiro combo para começar</p>
                <v-btn color="primary" elevation="0" @click="$router.push('/combos/novo')">
                    <v-icon class="mr-1">mdi-plus</v-icon> Novo Combo
                </v-btn>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogExcluir" max-width="360px">
            <v-card class="pa-4 text-center">
                <v-card-text class="pt-4">
                    <v-icon size="48" color="error" class="mb-3">mdi-trash-can-outline</v-icon>
                    <h3 class="text-h6 font-weight-bold mb-2">Excluir Combo</h3>
                    <p v-if="comboParaExcluir" class="grey--text text--darken-1">
                        Tem certeza que deseja excluir <strong>{{ comboParaExcluir.nome }}</strong>?
                    </p>
                </v-card-text>
                <v-card-actions class="justify-center pb-4">
                    <v-btn outlined color="grey darken-1" @click="dialogExcluir = false">Cancelar</v-btn>
                    <v-btn color="error" elevation="0" @click="excluirCombo">Excluir</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from '@/plugins/axios';
import { eventHub } from '@/main';

export default {
    name: 'ComboList',

    data() {
        return {
            search: '',
            activeTab: 'todos',
            comboParaExcluir: null,
            dialogExcluir: false,
            tabs: [
                { label: 'Todos',         value: 'todos'         },
                { label: 'Habilitados',   value: 'habilitados'   },
                { label: 'Desabilitados', value: 'desabilitados' },
            ],
            dataList: {
                loading: false,
            },
            combos: [],
        };
    },

    mounted() {
        this.loadData();
        eventHub.$on('CHANGE-OPERATION', () => this.loadData());
    },

    destroyed() {
        eventHub.$off('CHANGE-OPERATION');
    },

    computed: {
        filteredCombos() {
            return this.combos.filter(c => {
                const matchSearch = c.nome.toLowerCase().includes(this.search.toLowerCase());
                const matchTab =
                    this.activeTab === 'todos' ||
                    (this.activeTab === 'habilitados'   &&  c.habilitado) ||
                    (this.activeTab === 'desabilitados' && !c.habilitado);
                return matchSearch && matchTab;
            });
        },
    },

    methods: {
        async loadData() {
            this.dataList.loading = true;
            try {
                const operacaoId = localStorage.getItem('operation');
                if (!operacaoId) { this.combos = []; return; }
                const res = await axios.get('/api/combos', { params: { operacaoId } });
                this.combos = res.data.content || res.data;
            } catch (err) {
                this.$dialog.notify.error('Erro ao carregar combos.', { position: 'top-right', timeout: 4000 });
            } finally {
                this.dataList.loading = false;
            }
        },

        async toggleStatus(combo) {
            try {
                await axios.put(`/api/combos/${combo.id}`, {
                    ...combo,
                    operacaoId: localStorage.getItem('operation'),
                    habilitado: !combo.habilitado
                });
                combo.habilitado = !combo.habilitado;
            } catch (err) {
                this.$dialog.notify.error('Erro ao alterar status.', { position: 'top-right', timeout: 4000 });
            }
        },

        confirmarExclusao(combo) {
            this.comboParaExcluir = combo;
            this.dialogExcluir = true;
        },

        async excluirCombo() {
            this.dataList.loading = true;
            try {
                await axios.delete(`/api/combos/${this.comboParaExcluir.id}`);
                this.$dialog.notify.success('Combo excluído com sucesso.', { position: 'top-right', timeout: 3000 });
                this.dialogExcluir = false;
                this.comboParaExcluir = null;
                await this.loadData();
            } catch (err) {
                this.$dialog.notify.error('Erro ao excluir combo.', { position: 'top-right', timeout: 4000 });
            } finally {
                this.dataList.loading = false;
            }
        },
    },
};
</script>

<style scoped>
/* Estilos específicos mantendo o visual dos cards integrados ao Vuetify */
.combo-card {
    border-radius: 14px !important;
    border: 1.5px solid #EEEEEE !important;
    background: #ffffff;
    transition: transform 0.22s cubic-bezier(.34,1.56,.64,1), box-shadow 0.22s ease;
}
.combo-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 32px rgba(30,136,229,0.12) !important;
    border-color: #90CAF9 !important;
}
.card-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: #1E2A3A;
    margin: 0;
}
.value-box {
    border-radius: 10px;
}
.value-pago {
    background: #FFF8E1;
    border: 1px solid #FFE082;
}
.value-recebido {
    background: #E8F5E9;
    border: 1px solid #C8E6C9;
}
.value-amount {
    font-size: 1.15rem;
}
.ga-2 {
    gap: 8px;
}

@media (max-width: 768px) {
  .v-btn-toggle {
    display: flex !important;
    width: 100% !important;
  }

  .v-btn-toggle > .v-btn {
    flex: 1 !important;
    min-width: 0 !important;
    padding: 0 4px !important;
    font-size: 11px !important;
    letter-spacing: normal !important;
  }
}@media (max-width: 600px) {
  .title-container {
    flex-wrap: wrap;
  }

  .button-group {
    width: 100%;
    margin-top: 12px;
  }

  .button-group .v-btn {
    width: 100%;
    min-width: unset;
  }
}
</style>